export default "__VITE_ASSET__Bzx3_aXT__"